





































































































































































import Vue from 'vue';
import { Watch, Component, Prop } from 'vue-property-decorator';
import { Identity } from '@/store/consumer-application/types';
import { requiredRule, under18Rule } from '@/form-rules';

const VMask = require('v-mask').default;
Vue.use(VMask);

@Component({
	name: 'verify-reservation'
})
export default class VerifyReservation extends Vue {
	identity: Identity = {
		firstName: '',
		middleInitial: '',
		lastName: '',
		suffix: '',
		nameOnCard: '',
		dateOfBirth: '',
		taxId: ''
	};

	date = '';

	@Prop({required: true}) reservationCode!: string;
	dateOfBirthMenu = false; //for date picker
	showErrorIcon = false;
	state = '';
	disableVerifyButton = true;

	data() {
		return {
			show: false,
			birthDateRules: [
				requiredRule('Birth Date is required'),
				under18Rule('You must be at least 18 years of age to apply, or 19 years of age if residing in Alabama')
			],
			taxIdRules: [
				requiredRule('Social Security Number is required'),
			],
		};
	}

	verify() {
		const button = document.getElementById('verify');
		if (button != null) {
			button.classList.remove('verify-reservation-code-button');
			button.classList.add('verify-button-disabled-button-after-click');
		}		
		const url: string = '/api/kcas/enrollment/token/verify-token-data/' + this.reservationCode;
		const regex = /-/gi;
		const strippedTaxId = this.identity.taxId?.replace(regex, '');
		const body = [
			{
				key: 'taxId',
				value: strippedTaxId,
				validationFieldType:'TAXID',
			},
			{
				key: 'dob',
				value: this.identity.dateOfBirth,
				validationFieldType: 'DOB',
			},
		];
		this.$http
		.post(url, body)
			.then(() => {
				this.$emit('reservationCodeVerified');
			})
			.catch((error) => {
				if (error.response && error.response.status == 403) {
					if (error.response.data.verifyTries == 0) {
						this.state = 'failed';
						this.disableVerifyButton = true;
						return;
					}
					if (error.response.data.verifyTries > 0) {
						this.state = 'bad-verification';
						if (button != null) {
							button.classList.remove('verify-button-disabled-button-after-click');
							button.classList.add('verify-reservation-code-button');
						}							
						return;
					}
				}
				this.state = 'error';
				if (button != null) {
					button.classList.remove('verify-button-disabled-button-after-click');
					button.classList.add('verify-reservation-code-button');
				}		
			});
	}

	@Watch('identity.dateOfBirth')
	@Watch('identity.taxId')
	enableNextButtonIfCodeInputIsNotEmpty() {
		const verifyButton = document.getElementById('verify');
		if (this.identity.dateOfBirth && this.identity.taxId &&
				this.identity.dateOfBirth.length > 0 && this.identity.dateOfBirth < this.getOver18() && this.identity.taxId.length > 0) {
			this.disableVerifyButton = false;
		} else {
			this.disableVerifyButton = true;
			if(verifyButton !=  null && this.identity.dateOfBirth){
				verifyButton.classList.add('verify-button-error');
			}
		}
	}

	getOver18() {
		const dt = new Date();
		dt.setUTCHours(0,0,0,0);
		dt.setFullYear(dt.getFullYear() - 18);
		return dt.toISOString().substr(0, 10);
	}

	updateIdentity () {
		this.$store.commit('consumerApplication/SET_IDENTITY_FIELDS', this.identity, { root: true });
	}

	formatDate (date: string | undefined) {
		if (!date) return ''
		const [year, month, day] = date.split('-')
		return `${month}/${day}/${year}`
	}

	parseDate (date: string | undefined) {
		if (!date) return ''
		const [month, day, year] = date.split('/')
		return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
	}

	ssnOnFocus() {
		const ssnLabel = document.getElementById('ssn-label');
		if (ssnLabel != null) {
			ssnLabel.classList.remove('label');
			ssnLabel.classList.add('on-focus-label');
		}
	}

	dobOnFocus(){
		const dobLabel = document.getElementById('dob-label');
		if (dobLabel != null) {
			dobLabel.classList.remove('label');
			dobLabel.classList.add('on-focus-label');
		}
	}

	ssnOnBlur() {
		const ssnLabel = document.getElementById('ssn-label');
		if (this.identity.taxId != undefined){
			if (this.identity.taxId.length < 1 && ssnLabel != null) {
				ssnLabel.classList.remove('on-focus-label');
				ssnLabel.classList.add('label');
			}
		}
	}

	/* A defect was discovered that effects the font size of the label when a date is entered into the 
		field using the date picker and the field is on blur immediately after entering the date */
	dobOnBlur() {
		const dobLabel = document.getElementById('dob-label');
		const verifyButton = document.getElementById('verify-button-container');
		if (this.identity.dateOfBirth != undefined) {
			if (this.identity.dateOfBirth.length < 1 && dobLabel != null && verifyButton != null) {
				dobLabel.classList.remove('on-focus-label');
				dobLabel.classList.add('label');
				verifyButton.classList.add('verify-button-error');
			}
		}
	}
}
